import React from "react";
import { Box, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import CompareIcon from "@mui/icons-material/Compare";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
const columns = [
  { id: "name", label: "Prism Inc.", minWidth: 210 },
  { id: "code", label: "VS", minWidth: 50, align: "center" },
  {
    id: "population",
    label: "Clorox",
    minWidth: 170,
    align: "right",
  },
];
function createData(name, code, population, size) {
  return { name, code, population };
}
const rows = [
  createData(
    "Eco-friendliness",
    "Biodegradable Non-Woven Fabric",
    "Non-Biodegradable PP Non-Woven Fabric"
  ),
  createData(
    "Disinfection",
    "Kills 99.9% of Germs in as little as 60 Seconds",

    "Kills 99.9% of Germs in as little as 60 Seconds"
  ),
  createData(
    "Anti-Bacterial Durability ",
    "7 Days of Long-Lasting Anti-Bacterial Protection",

    "None"
  ),
  createData(
    "Chemicals",
    "Free of Ethanol, Benzalkonium, and Isopropanol ",

    "None"
  ),
  createData(
    "Respiratory Health",
    "No Damage to Respiratory System (No Harmful Chemicals) ",

    "Bad for Respiratory System (Hazardous Chemicals)"
  ),
  createData(
    "Skin Protection",
    "No Damage to Hand Skin (No Harmful Chemicals)",

    "Organic Chemicals Cause Dry Hands"
  ),
  createData("Deodorization", "99.9% Deodorization Effect ", "None"),
  createData("Scent", "100% Pure Phytoncide Oil", "Citrus Scent"),
];

const CompareTable = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <Box
        sx={{
          width: 1,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          pb: 20,
        }}
      >
        <Box
          maxWidth="lg"
          sx={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "grey",
            alignItems: "center",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <CompareArrowsIcon
              sx={{
                fontSize: "26px",
                color: "white",
                border: "1px solid #365672",
                backgroundColor: "#365672",
                borderRadius: "100px",
                padding: "15px",
              }}
            />
            <Box className="textTitle" sx={{ pt: 3 }}>
              Let's compare
            </Box>
            <Typography sx={{ pb: 6, pt: 1 }}>
              {/* Our product is FDA approved, Organic and Eco-friendly for you and
							your family. Every product is made in Korea. */}
            </Typography>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {/* {columns.map((column) => (
										<TableCell
											key={column.id}
											align={column.align}
											style={{ minWidth: column.minWidth }}
										>
											{column.label}
										</TableCell>
									))} */}
                      <TableCell
                        align="center"
                        style={{ minWidth: "120px" }}
                      ></TableCell>
                      <TableCell
                        align="left"
                        style={{
                          minWidth: "120px",
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#365672",
                          textAlign: "left",
                        }}
                      >
                        Our Sanitizing Wipes
                      </TableCell>

                      <TableCell
                        align="right"
                        style={{
                          minWidth: "120px",
                          fontSize: "20px",
                          color: "#03409a",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        Clorox
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.code}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  sx={{
                                    fontSize: { md: "15px", sm: "12px" },
                                    textAlign: "left",
                                  }}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CompareTable;
